import { Component } from 'react'
import { appRef } from '../../app'
import { HiOutlineExclamationCircle } from 'react-icons/hi'

export class NotFound extends Component {
    componentDidMount = () => {
        appRef.setHeader(<HiOutlineExclamationCircle className="me-2" size={28} />, () => 'Not Found')
    }

    render() {
        return (
            <div className="h-full w-full flex items-center justify-center">
                <h1 className="dark:text-white text-4xl">Are you lost?</h1>
            </div>
        )
    }
}
